import api from "./api/client";

/**
 * GET /freight/transport-queues/summary
 * Retorna fretes elegíveis + filas de transportadoras agregadas.
 */
export async function fetchTransportQueueHubSummary(params = {}) {
  const response = await api.get("/freight/transport-queues/summary", {
    params,
  });
  return response?.data?.data ?? response?.data ?? {};
}

/**
 * POST /freight/{freightId}/transport-queue/accept
 * Aceita uma transportadora da fila e atribui ao frete.
 */
export async function acceptTransportQueueHubCandidate({
  freightId,
  idCarrier,
  nameCarrier,
  idUser,
  viewAll,
}) {
  const response = await api.post(
    `/freight/${freightId}/transport-queue/accept`,
    {
      idCarrier,
      nameCarrier,
      idUser,
    },
    { params: withViewAll({ viewAll }) },
  );
  return response?.data?.data ?? response?.data ?? {};
}

function withViewAll(params, extra = {}) {
  const next = { ...extra };
  if (params?.viewAll === true || params?.viewAll === "true") {
    next.viewAll = "true";
  }
  return next;
}

export async function counterTransportQueueHubCandidate({
  freightId,
  idCarrier,
  nameCarrier,
  idUser,
  amount,
  viewAll,
}) {
  const response = await api.post(
    `/freight/${freightId}/transport-queue/counter`,
    { idCarrier, nameCarrier, idUser, amount },
    { params: withViewAll({ viewAll }) },
  );
  return response?.data?.data ?? response?.data ?? {};
}

export async function rejectTransportQueueHubCandidate({
  freightId,
  idCarrier,
  nameCarrier,
  idUser,
  viewAll,
}) {
  const response = await api.post(
    `/freight/${freightId}/transport-queue/reject`,
    { idCarrier, nameCarrier, idUser },
    { params: withViewAll({ viewAll }) },
  );
  return response?.data?.data ?? response?.data ?? {};
}
